import normalize from 'json-api-normalizer'

import { bulkUpsert, fetchEntities, updateEntity } from 'actions/entities'
import { getJson, postJson } from 'api_helpers'

function syncResponse (dispatch) {
  return (response) => response.json().then((json) => {
    if (json && json.data) {
      const normalized = normalize(json)
      Object.keys(normalized).forEach((key) => dispatch(bulkUpsert(key, normalized[key])))
    }
    return json
  })
}

export function fetchBillingInvoice (id) {
  return (dispatch) => getJson(Routes.superuser_api_billing_invoice_path({ id })).then(syncResponse(dispatch))
}

export function fetchBillingSupplierConfig () {
  return (dispatch) => getJson(Routes.superuser_api_billing_supplier_config_path()).then(syncResponse(dispatch))
}

export function pauseSubscription (id) {
  return (dispatch) => {
    dispatch(updateEntity('billingSubscription', { id, status: 'paused' }))
    return postJson(Routes.pause_superuser_api_billing_subscription_path({ id })).then(syncResponse(dispatch))
  }
}

export function resumeSubscription (id) {
  return (dispatch) => {
    dispatch(updateEntity('billingSubscription', { id, status: 'active' }))
    return postJson(Routes.resume_superuser_api_billing_subscription_path({ id })).then(syncResponse(dispatch))
  }
}

export function cancelSubscription (id) {
  return (dispatch) => {
    dispatch(updateEntity('billingSubscription', { id, status: 'cancelled' }))
    return postJson(Routes.cancel_superuser_api_billing_subscription_path({ id })).then(syncResponse(dispatch))
  }
}

export function previewSubscriptionInvoice (id, runDate) {
  return () => getJson(Routes.preview_invoice_superuser_api_billing_subscription_path({ id, run_date: runDate }))
    .then((res) => res.json())
}

export function sendBillingInvoiceEmail (id) {
  return (dispatch) => {
    dispatch(updateEntity('billingInvoice', { id, status: 'sending' }))
    return postJson(Routes.send_email_superuser_api_billing_invoice_path({ id })).then(syncResponse(dispatch))
  }
}

export function sendBillingInvoicePeppol (id) {
  return (dispatch) => {
    dispatch(updateEntity('billingInvoice', { id, sendPeppolWarning: 'sending' }))
    return postJson(Routes.send_peppol_superuser_api_billing_invoice_path({ id })).then(syncResponse(dispatch))
  }
}

export function markBillingInvoicePaid (id, paidOn) {
  return (dispatch) => {
    dispatch(updateEntity('billingInvoice', { id, payedAt: paidOn, status: 'paid' }))
    return postJson(Routes.mark_paid_superuser_api_billing_invoice_path({ id }), { paid_on: paidOn })
      .then(syncResponse(dispatch))
  }
}

export function unmarkBillingInvoicePaid (id) {
  return (dispatch) => {
    dispatch(updateEntity('billingInvoice', { id, payedAt: null }))
    return postJson(Routes.unmark_paid_superuser_api_billing_invoice_path({ id })).then(syncResponse(dispatch))
  }
}

export function creditNoteBillingInvoice (id, reason) {
  return (dispatch) => postJson(Routes.credit_note_superuser_api_billing_invoice_path({ id }), { reason })
    .then(syncResponse(dispatch))
}

export function triggerBillingRun (runDate) {
  return (dispatch) => postJson(Routes.trigger_superuser_api_billing_runs_path(), { run_date: runDate })
    .then((res) => {
      if (!res.ok) return res.text().then((body) => { throw new Error(`HTTP ${res.status}: ${body}`) })
      return res.json()
    })
    .then((result) => {
      dispatch(fetchEntities('billingRuns'))
      dispatch(fetchEntities('billingInvoices'))
      return result
    })
}

export function fetchBillingInvoiceStats (period) {
  return () => getJson(Routes.stats_superuser_api_billing_invoices_path({ period })).then((res) => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`)
    return res.json()
  })
}
